import { createContext, useContext } from 'react';
import { User } from '../../../lib/interfaces';

export const UserContext = createContext<User | undefined>(undefined);

export const useUser = () => useContext(UserContext);
